import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="container-x py-32" data-testid="not-found-page">
      <p className="eyebrow">404</p>
      <h1 className="mt-6 font-display text-5xl font-light">This room is empty.</h1>
      <Link to="/gallery" className="link-u mt-10">Return to the collection</Link>
    </div>
  );
}
